module.exports = __webpack_public_path__ + "img/icon_score.d54aa270.svg";